var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAcademy = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #000;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fab29b;\r\n      }\r\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 22.9,
    y: 143,
    width: 426.1,
    height: 300,
    rx: 17.6,
    ry: 17.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "school"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M480.8,457.4V186.4c13.7-1.6,24.4-13.1,24.4-27.1s-12.3-27.5-27.5-27.5h-8.4L260.9,1.2c-2.6-1.6-5.9-1.6-8.5,0L43.9,131.8h-9.6c-15.1,0-27.5,12.3-27.5,27.5s11.3,26.3,25.6,27.3v270.8c-13.5,1.7-24.1,13.1-24.1,27.2,0,15.1,12.3,27.5,27.5,27.5h441.7c15.1,0,27.5-12.3,27.5-27.5,0-14.1-10.6-25.5-24.2-27.2ZM314.2,457v-77.3c0-31.7-25.8-57.5-57.5-57.5s-57.5,25.8-57.5,57.5v77.3H48.5V186.7h416.3v270.3h-150.5ZM298.2,457h-83.1v-77.3c0-22.9,18.6-41.5,41.5-41.5s41.5,18.6,41.5,41.5v77.3h0ZM256.6,17.4l182.5,114.3H74.1L256.6,17.4ZM22.9,159.3c0-6.3,5.1-11.5,11.5-11.5h443.3c6.3,0,11.5,5.2,11.5,11.5s-5.1,11.5-11.5,11.5H34.3c-6.3,0-11.5-5.1-11.5-11.5ZM477.5,496H35.8c-6.3,0-11.5-5.1-11.5-11.5s5.1-11.5,11.5-11.5h441.7c6.3,0,11.5,5.2,11.5,11.5s-5.1,11.5-11.5,11.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M160.3,288h-6.2v-35.9c0-17.2-14-31.2-31.2-31.2s-31.2,14-31.2,31.2v35.9h-6.2c-4.4,0-8,3.6-8,8s3.6,8,8,8h74.7c4.4,0,8-3.6,8-8s-3.6-8-8-8ZM107.7,288v-35.9c0-8.4,6.8-15.2,15.2-15.2s15.2,6.8,15.2,15.2v35.9h-30.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M160.3,394.6h-6.2v-35.9c0-17.2-14-31.2-31.2-31.2s-31.2,14-31.2,31.2v35.9h-6.2c-4.4,0-8,3.6-8,8s3.6,8,8,8h74.7c4.4,0,8-3.6,8-8s-3.6-8-8-8ZM107.7,394.6v-35.9c0-8.4,6.8-15.2,15.2-15.2s15.2,6.8,15.2,15.2v35.9h-30.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M353.9,304h74.7c4.4,0,8-3.6,8-8s-3.6-8-8-8h-6.2v-35.9c0-17.2-14-31.2-31.2-31.2s-31.2,14-31.2,31.2v35.9h-6.2c-4.4,0-8,3.6-8,8s3.6,8,8,8h0ZM376.1,252c0-8.4,6.8-15.2,15.2-15.2s15.2,6.8,15.2,15.2v35.9h-30.4v-35.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M428.6,394.6h-6.2v-35.9c0-17.2-14-31.2-31.2-31.2s-31.2,14-31.2,31.2v35.9h-6.2c-4.4,0-8,3.6-8,8s3.6,8,8,8h74.7c4.4,0,8-3.6,8-8s-3.6-8-8-8h0ZM376.1,394.6v-35.9c0-8.4,6.8-15.2,15.2-15.2s15.2,6.8,15.2,15.2v35.9h-30.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M297.6,288h-6.2v-35.9c0-17.2-14-31.2-31.2-31.2s-31.2,14-31.2,31.2v35.9h-6.2c-4.4,0-8,3.6-8,8s3.6,8,8,8h74.7c4.4,0,8-3.6,8-8s-3.6-8-8-8ZM245.1,288v-35.9c0-8.4,6.8-15.2,15.2-15.2s15.2,6.8,15.2,15.2v35.9h-30.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M280,66.3c-5-6.4-12.2-10.4-20.3-11.4-8.1-1-16,1.2-22.4,6.3-6.4,5-10.5,12.3-11.4,20.3-2,16.7,9.9,31.9,26.6,33.9,1.2.1,2.5.2,3.7.2,15.2,0,28.3-11.4,30.2-26.8,1-8.1-1.3-16.1-6.3-22.5ZM270.4,86.8c-1,7.9-8.2,13.6-16.1,12.6-3.8-.5-7.3-2.4-9.6-5.4-2.4-3-3.4-6.8-3-10.7.5-3.8,2.4-7.3,5.4-9.6,2.6-2,5.7-3.1,8.9-3.1s1.2,0,1.8.1c0,0,0,0,0,0,3.8.5,7.3,2.4,9.7,5.4,2.4,3,3.5,6.8,3,10.6h0Z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAcademy);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Academy.c76de65b2aae284883dd9b1bf9da7d7e.svg";